import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { Caption } from '../../Common/Caption';

import { PlusIcon } from '../../Icon/PlusIcon';

const StyledWrapper = styled.div`
  img {
    width: 100%;
    
    @media (min-width: 768px) {
      max-width: 450px;
    }
  }
`;
const StyledCloseIconWrapper = styled.span`
  width: 30px;
  height: 30px;
  top: -15px;
  right: -15px;
  padding: 4px;
  position: absolute;
  z-index: 99;
  cursor: pointer;
  transform: rotate(45deg);
`;

type Props = {
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  colourSwatch: string;
  colourName: string;
};

export const ProductSwatchModal = ({
  modalIsOpen,
  openModal,
  closeModal,
  colourSwatch,
  colourName,
}: Props) => {
  const customStyles = {
    overlay: {
      zIndex: 999,
      backgroundColor: 'rgb(36,35,37, 0.25)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      borderRadius: '10px',
      padding: '1rem',
      overflow: 'visible',
    },
  };

  Modal.setAppElement('#root');

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <StyledWrapper>
        <StyledCloseIconWrapper onClick={closeModal}>
          <PlusIcon />
        </StyledCloseIconWrapper>
        <img src={colourSwatch} />
        {colourName && <Caption>{colourName}</Caption>}
      </StyledWrapper>
    </Modal>
  );
};
